module.exports = __webpack_public_path__ + "static/hero_de-97bbe1d28e35e9c2b9ac07657fbc0bc0.png";